import { forwardRef } from "react";
import {
  ToggleButton as MuiToggleButton,
  ToggleButtonProps as MuiToggleButtonProps,
} from "@mui/material";

export type TToggleButtonProps = MuiToggleButtonProps;

const ToggleButton = forwardRef<HTMLButtonElement, TToggleButtonProps>(
  (props, ref) => <MuiToggleButton ref={ref} {...props} />,
);

export default ToggleButton;
